import { render, staticRenderFns } from "./SettingResult.vue?vue&type=template&id=118f42aa&"
import script from "./SettingResult.vue?vue&type=script&lang=js&"
export * from "./SettingResult.vue?vue&type=script&lang=js&"
import style0 from "./SettingResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports